import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import {
    LOCATION_INITIALIZED,
    LOCATION_OVERRIDE_INITIALIZED,
    LOCATION_OVERRIDE_SELECTED,
    LOCATION_SELECTED,
} from "./actions"
import { ACCOUNT_SELECTED, COOKIE_LOADED } from "../../auth/actions"
import { LOG_OUT_FAILURE, LOG_OUT_SUCCESS } from "../../layouts/header/actions"

export type LocationsPickerState = {
    selectedLocationOverrideId: Maybe<string>
    selectedLocationId: Maybe<string>
}

export const createDefaultLocationsPickerState = () => ({
    selectedLocationOverrideId: null,
    selectedLocationId: null,
})
export const locationsPickerReducer = (state: Maybe<LocationsPickerState> = undefined, action: Record<string, any>) => {
    if (!state) {
        return createDefaultLocationsPickerState()
    }

    switch (action.type) {
        case COOKIE_LOADED:
            return {
                ...state,
                selectedLocationId: action.payload.locationId,
                selectedLocationOverrideId: action.payload.locationOverrideId,
            }

        case LOCATION_SELECTED:
        case LOCATION_INITIALIZED:
            return { ...state, selectedLocationId: action.payload.locationId }

        case LOCATION_OVERRIDE_INITIALIZED:
        case LOCATION_OVERRIDE_SELECTED:
            return { ...state, selectedLocationOverrideId: action.payload.locationId }

        case ACCOUNT_SELECTED:
        case LOG_OUT_SUCCESS:
        case LOG_OUT_FAILURE:
            return createDefaultLocationsPickerState()

        default:
            return state
    }
}
